import { Box, Typography } from '@mui/material';

import { PageWrapper } from '@/components/PageWrapper';

export function Legal() {
  return (
    <PageWrapper>
      <Typography>
        Das Internetportal wird für das Forschungsprojekt mCube Projekt DatSIM 2.0 durch die Trafficon Software GmbH,
        Strubergasse 26, A-5020 Salzburg betrieben.
      </Typography>
      <Typography gutterBottom variant="h6">
        1. SSL-Verschlüsselung
      </Typography>
      <Typography paragraph>
        a) Unser Internetportal verwendet aus Gründen der Sicherheit und zum Schutz der Übertragung vertraulicher
        Inhalte, wie zum Beispiel von Anfragen, die Nutzer über das Portal an uns senden, eine SSL-Verschlüsselung. Eine
        verschlüsselte Verbindung erkennt man daran, dass die Adresszeile des Browsers von &bdquo;http://&ldquo; auf
        &bdquo;https://&ldquo; wechselt und die Browserzeile ein Vorhängeschloss-Symbol enthält.
      </Typography>
      <Typography paragraph>
        b) Wenn die SSL Verschlüsselung aktiviert ist, können die Daten, die vom Nutzer an uns übermittelt werden, im
        Regelfall nicht von Dritten mitgelesen werden.
      </Typography>

      <Typography gutterBottom variant="h6">
        2. Umfang und Zweck der Verarbeitung personenbezogener Daten
      </Typography>
      <Typography paragraph>
        a) Wir speichern Daten über jeden Zugriff eines Nutzers auf das Angebot unseres Internetportals über die
        Server-Logfiles. Des Weiteren erfassen wir auftretende Fehler bei der Nutzung des Internetportals. Zugriffsdaten
        sind:
      </Typography>
      <Box component="ul" sx={{ pl: 4 }}>
        <Typography component="li">Der Name der abgerufenen Webseite</Typography>
        <Typography component="li">Datum und Uhrzeit der Serveranfrage</Typography>
        <Typography component="li">Die übertragene Datenmenge</Typography>
        <Typography component="li">Browsertyp/ Browserversion</Typography>
        <Typography component="li">Das vom Nutzer verwendete Betriebssystem</Typography>
        <Typography component="li">Die IP-Adresse des Nutzers</Typography>
      </Box>
      <Typography paragraph>
        b) Diese Protokolldaten werden von uns nur für statistische Auswertungen zum Zweck des Betriebs, der Sicherheit
        und der Optimierung des Angebots auf dem Internetportal verwendet. Wir behalten uns jedoch vor, die
        Protokolldaten nachträglich zu prüfen, wenn wir aufgrund konkreter Anhaltspunkte Kenntnis über eine
        rechtswidrige Nutzung erhalten oder der berechtigte Verdacht einer rechtswidrigen Nutzung besteht.
      </Typography>
    </PageWrapper>
  );
}
